import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const { BASE_API, BASE_XHH } = extractAPIValues()

// 获取token跟cdn路径
export function getCdnToken (args, formdata) {
	let url = BASE_XHH + '/bbs/app/api/qcloud/cos/upload/info/v2'
	return axiosPostHandler(url, args, formdata)
}

// 上传表情
export function uploadRoomCustomEmoji (args, formdata) {
	let url = BASE_API + '/chatroom/v2/msg/meme/room/upload'
	return axiosPostHandler(url, args, formdata)
}

// 获取房间表情包
export function getRoomCustomEmoji (args) {
	let url = BASE_API + '/chatroom/v1/msg/meme/room'
	return axiosGetHandler(url, args)
}

// 添加房间表情包
export function addRoomCustomEmoji (args, formdata) {
	let url = BASE_API + '/chatroom/v1/msg/meme/add'
	return axiosPostHandler(url, args, formdata)
}

// 删除房间表情包
export function delRoomCustomEmoji (args, formdata) {
	let url = BASE_API + '/chatroom/v1/msg/meme/del'
	return axiosPostHandler(url, args, formdata)
}

// 修改房间表情包
export function editRoomCustomEmoji (args, formdata) {
	let url = BASE_API + '/chatroom/v1/msg/meme/modify_name'
	return axiosPostHandler(url, args, formdata)
}

// 获取所有表情包列表
export function getAllMemeList(args) {
  let url = BASE_API + '/chatroom/v1/msg/meme/list'
  return axiosGetHandler(url, args)
}

// 上传用户表情包
export function uploadUserCustomEmoji (args, formdata) {
	let url = BASE_API + '/chatroom/v2/msg/meme/user/upload'
	return axiosPostHandler(url, args, formdata)
}

// 修改用户表情包
export function editUserCustomEmoji (args, formdata) {
	let url = BASE_API + '/chatroom/v1/msg/meme/user_modify_name'
	return axiosPostHandler(url, args, formdata)
}

// 删除用户表情包
export function delUserCustomEmoji (args, formdata) {
	let url = BASE_API + '/chatroom/v1/msg/meme/user_del'
	return axiosPostHandler(url, args, formdata)
}

// 添加用户表情包
export function addUserCustomEmoji (args, formdata) {
	let url = BASE_API + '/chatroom/v1/msg/meme/user_add'
	return axiosPostHandler(url, args, formdata)
}

// 过滤被数美的表情
export function filterCustomEmoji (args, formdata) {
	let url = BASE_API + '/chatroom/v2/msg/meme/filter'
	return axiosPostHandler(url, args, formdata)
}
